import {listGender, listTT_Don_Kinh} from "data/list";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
const {INPUT, AUTO_COMPLETE, DATE, COMBO_BOX, TRA_THUOC} = FIELD_TYPE;

import {DataFormField} from "types/models/input-field-type";

const fields: DataFormField[] = [
  {
    type: AUTO_COMPLETE,
    label: "Tên BN/KH",
    name: "hoTen",
    rules: [{required: true, message: "Chưa nhập tên khách hàng"}],
  },
  {
    type: DATE,
    label: "Ngày sinh",
    name: "ngaySinh",
  },

  {
    type: COMBO_BOX,
    label: "Giới tính",
    name: "gioiTinh",
    options: listGender,
  },

  {
    type: INPUT,
    label: "SĐT",
    name: "dienThoai",
  },
  {
    type: INPUT,
    label: "Mã bệnh nhân",
    name: "maBenhNhan",
    disable: true,
  },
  {
    type: INPUT,
    label: "Mã phiếu khám",
    name: "maPK",
    disable: true,
  },
  {
    type: INPUT,
    label: "Mã đơn kính",
    name: "id",
    disable: true,
  },
  {
    type: INPUT,
    label: "BS kê đơn",
    name: "tenBacSy",
    disable: true,
  },
  {
    type: DATE,
    label: "Thời gian bán",
    name: "thoiGianBan",
    optionsTime: {showTime: true, format: FORMAT_TIME.dateTime},
    disable: true,
  },
  {
    type: DATE,
    label: "Thời gian hoàn trả",
    name: "thoiGianTra",
    optionsTime: {showTime: true, format: FORMAT_TIME.dateTime},
    disable: true,
  },
  {
    type: INPUT,
    label: "Địa chỉ",
    name: "diaChi",
  },
  {
    type: COMBO_BOX,
    label: "Trạng thái",
    name: "status",
    options: listTT_Don_Kinh,
    disable: true,
  },
  {
    type: COMBO_BOX,
    label: "Kho",
    name: "storeId",
    rules: [{required: true, message: "Chưa chọn kho"}],
  },
  {
    type: INPUT,
    label: "Ghi chú",
    name: "ghiChu",
  },
];
export {fields};
